import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post, Req, UploadedFile, UseInterceptors } from '@nestjs/common';
import { ApiConsumes, ApiTags } from '@nestjs/swagger';
import { MasterBrand } from './master-brands.entity';
import { MasterBrandAdapter } from './dto/master-brands.adapter';
import { MasterBrandDTO } from './dto/master-brands.dto';
import { MasterBrandRequest } from './dto/master-brands.request';
import { MasterBrandsService } from './master-brands.service';
import { AllMasterBrandsResponseModel, BrandIDReq, MasterBrandResponse, MasterBrandResponseModel, MasterBrandsResponseModel, MasterDropDownResponseModel } from '@gtpl/shared-models/masters';
import { FileInterceptor } from '@nestjs/platform-express';
import { extname } from 'path';
import { BrandUploadResponse } from './dto/master-brand-file-upload';
import { diskStorage } from 'multer';
import { BrandRequest } from '../end-customer/dto/brand.request';
import { UserRequestDto } from '../currencies/dto/user-logs-dto';
import { CommonResponse } from '@gtpl/shared-models/production-management';

@ApiTags('master-brands')
@Controller('master-brands')
export class MasterBrandsController {


    constructor(
        private brandService: MasterBrandsService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler,
      ) {}

      @Post('/createMasterBrand')
      async createMasterBrand(@Body() brandDto:MasterBrandDTO,isUpdate:boolean=false,@Req() request:Request): Promise<MasterBrandResponseModel> {
          try {
           return await this.brandService.createMasterBrand(brandDto,false,request);
         } catch (error) {
              return this.applicationExceptionHandler.returnException(MasterBrandResponseModel, error);
         }
       }

       @Post('/brandUpload')
       @ApiConsumes('multipart/form-data')
       @UseInterceptors(FileInterceptor('file', {
         limits: { files: 1 },
         storage: diskStorage({
           destination: './upload-files/brand-files',
           filename: (req, file, callback) => {
             const name = file.originalname.split('.')[0];
             const fileExtName = extname(file.originalname);
             const randomName = Array(4)
               .fill(null)
               .map(() => Math.round(Math.random() * 16).toString(16))
               .join('');
             callback(null, `${name}-${randomName}${fileExtName}`);
           },
         }),
         fileFilter: (req, file, callback) => {
           if (!file.originalname.match(/\.(png|jpeg|jpg|JPG)$/)) {
             return callback(new Error('Only png,jpeg files are allowed!'), false);
           }
           callback(null, true);
         },
       }))
       async brandUpload(@UploadedFile() file, @Body() uploadData: MasterBrandDTO): Promise<MasterBrandResponseModel> {
         try {
          //  console.log(file);
           console.log('**********&&&&&&************')
           console.log(uploadData)
           if(file){
            uploadData.filePath = file.path;
            uploadData.fileName = file.filename;
           }
           return await this.brandService.createMasterBrand(uploadData,false);
         } catch (error) {
           return this.applicationExceptionHandler.returnException(MasterBrandResponseModel, error);
         }
       }




       
      @Post('/getAllMasterBrands')
      async getAllMasterBrands(@Body() req?:UserRequestDto): Promise<AllMasterBrandsResponseModel> {
          try {
              return await this.brandService.getAllMasterBrands(req);
          } catch (error) {
              return this.applicationExceptionHandler.returnException(AllMasterBrandsResponseModel, error);
          }
      }

      @Post('/updateMasterBrand')
      async updateMasterBrand(@Body() brandDto:MasterBrandDTO,isUpdate:boolean=true,@Req() request:Request): Promise<MasterBrandResponseModel> {
          try {
           return await this.brandService.createMasterBrand(brandDto,true,request);
         } catch (error) {
              return this.applicationExceptionHandler.returnException(MasterBrandResponseModel, error);
         }
       }

      @Post('/activateOrDeactivateMasterBrand')
      async activateOrDeactivateMasterBrand(@Body() brandReq: MasterBrandRequest): Promise<MasterBrandResponseModel> {
          try {
              return await this.brandService.activateOrDeactivateMasterBrand(brandReq);
          } catch (err) {
              return this.applicationExceptionHandler.returnException(MasterBrandResponseModel, err);
          }
      }

     @Post('/getAllMasterBrandsDropDown')
     async getAllMasterBrandsDropDown():Promise<MasterDropDownResponseModel>{
        try {
            return await this.brandService.getAllMasterBrandsDropDown();
        } catch (err) {
            return this.applicationExceptionHandler.returnException(MasterDropDownResponseModel, err);
        }
     }

     @Post('/getMasterBrandById')
     async getMasterBrandById(@Body() brandReq: BrandRequest):Promise<MasterBrand>{
        try {
            return await this.brandService.getMasterBrandById(brandReq.brandId);
        } catch (err) {
            return err;
        }
     }

     @Post('/getBrandInfoById')
     async getBrandInfoById(@Body() brandReq: BrandRequest):Promise<MasterBrandResponseModel>{
        try {
            return await this.brandService.getBrandInfoById(brandReq.brandId);
        } catch (err) {
          return this.applicationExceptionHandler.returnException(MasterBrandResponseModel, err);
        }
      }
      
     @Post('/getMasterBrandForId')
     async getMasterBrandForId(@Body() brandReq: BrandRequest): Promise<MasterBrandResponse> {
        try {
            return await this.brandService.getMasterBrandForId(brandReq.brandId);
        } catch (err) {
            return err;
        }
     }
     @Post('/getAllActiveMasterBrands')
    async getAllActiveMasterBrands(): Promise<MasterBrandsResponseModel> {
        try {
            return await this.brandService.getAllActiveMasterBrands();
        } catch (err) {
            return err;
        }
     }

     @Post('/getDisplayBrandsById')
     async getDisplayBrandsById(@Body() req:BrandIDReq): Promise<CommonResponse> {
         try {
             return await this.brandService.getDisplayBrandsById(req);
         } catch (err) {
             return err;
         }
      }
  

}
// function diskStorage(arg0: { destination: string; filename: (req: any, file: any, callback: any) => void; }): any {
//     throw new Error('Function not implemented.');
// }

